import type { ApiResponse } from '../common/ApiResponse';

export const DEFAULT_TOKEN_DURATION_MINUTES = 480;
export const MIN_TOKEN_DURATION_MINUTES = 5;
export const MAX_TOKEN_DURATION_MINUTES = 10080;

export type TokenDurationUnit = 'minutes' | 'hours';

export interface TokenConfiguration {
  id: number;
  durationMinutes: number;
  durationHours: number;
  updatedAt: string | null;
}

export interface TokenConfigurationRequest {
  durationMinutes: number;
}

export type CustomResponse<T> = ApiResponse<T>;
